<template>
    <div class="modal-you-are-locked-wrapper" v-if="showModal">

        <div class="container modal-you-are-locked-top">
            <span class="cursor-pointer p-1 modal-you-are-locked-close mt-0 mt-md-5" @click="closeModal">X</span>
        </div>

        <div class="small-container modal-you-are-locked-content px-5">

            <span class="d-flex flex-column justify-content-center align-items-start w-100">
                <p class="mb-0 mt-n3 mt-md-0"><b>{{ translate.account.lockedProfile.yourProfileIsLocked }}</b></p>
                <p>{{ translate.account.lockedProfile.yourProfileIsLockedInfo }}</p>
            </span>

            <div class="profile-block profile-block--lock my-0 my-md-4">
                <span class="profile-block-images" v-if="lodash.get(currentUser,'photos',[]).length > 0">
                    <div class="plus-box-shadow"></div>
                    <img :src="getPhotoUrlByName(currentUser.photos[0].name,currentUser.id,'jpg','medium')" alt=""/>
                </span>

                <span class="profile-block-images" v-else>
                    <div class="plus-box-shadow"></div><img :src="noPhotoUrl" alt=""/>
                </span>

                <span class="profile-block-details">
                    <span class="user-details overflow-hidden">
                        <span class="heading-1">{{ currentUser.username + getUserAge(currentUser, ', ') }}</span>
                        <span class="user-details-location d-flex overflow-hidden">
                            <span class="text-ellipsis">{{ currentUser.city || 'Hamburg' }}</span>
                            <span class="distance">3.4km</span>
                        </span>
                    </span>
                </span>
            </div>

            <span class="d-flex flex-column justify-content-center align-items-start w-100">
                <p class="mt-2">{{ translate.account.lockedProfile.upgradeToday }}</p>
            </span>

            <span class="btn btn-gold w-100 cursor-pointer" @click="goToPremium">
                <span>{{ translate.account.lockedProfile.upgradeToGold }}</span>
                <icon-component class="ml-4 h-100" :icon="fa_stars_regular()"></icon-component>
            </span>

            <span class="modal-you-are-locked-not-now cursor-pointer text-underline mt-2" @click="closeModal">
                {{ translate.account.lockedProfile.noThanks }}
            </span>

        </div>
    </div>
</template>
<script>

import RegularEscortViewComponent from "@/components/search/partials/RegularEscortViewComponent.vue";
import userMixin from "@/components/mixins/userMixin";
import photoMixin from "@/components/mixins/photoMixin";
import {disableScroll, enableScroll} from "@/core/utils/helpers/GlobalCssHelpers";
import CookiesEnum from "@/core/constants/cookiesEnum";
import {getCookie} from "@/core/utils/helpers/cookieHelper";
import {fa_stars_regular} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";
import {NuxtRoutes} from "@/core/constants/v2/nuxtRoutes";

const data = () => {
    return {
        lodash: _,
        store: $store,
        noPhotoUrl: constants.user_photo.NO_PHOTO_SEARCH_URL,
        forceClose: false,
        loginTimesWhenToShowModal: [1, 3],
    }
};

function goToPremium() {
    this.closeModal();

    window.location.href = regionRelativeUrl(NuxtRoutes.PRODUCTS.BUY_PREMIUM);
}

function closeModal() {
    this.forceClose = true;
    this.store.commit('setProfileBlurredModalForceShow', false);
}

export default {
    data,
    computed: {
        ...mapState(['translate', 'currentUser', 'mainAccountComponentWasLoadedBefore', 'profileBlurredModalForceShow']),
        showModal() {
            if(!this.currentUser){
                return false;
            }

            if (this.profileBlurredModalForceShow) {
                return true;
            }

            if (this.forceClose || !_.get(this, 'currentUser.is_blurred') || this.mainAccountComponentWasLoadedBefore) {
                return false;
            }

            if (typeof userNavigatedFromLogin === "undefined" || !userNavigatedFromLogin) {
                return false;
            }

            const userTodayLoginCounter = getCookie(CookiesEnum.USER_TODAY_LOGIN_COUNTER)
            if (!userTodayLoginCounter) {
                return false;
            }

            if (!this.loginTimesWhenToShowModal.includes(parseInt(userTodayLoginCounter))) {
                return false;
            }

            const isPublished = !!_.get(this, 'currentUser.profile_path.length');
            const hasGoldOrSilver = this.isGoldUser(this.currentUser) || this.isSilverUser(this.currentUser)

            return isPublished && !hasGoldOrSilver;
        }
    },
    watch: {
        showModal(value) {
            if (value) {
                disableScroll();
            } else {
                enableScroll();
            }
        }
    },
    beforeDestroy() {
        enableScroll();
    },
    mixins: [userMixin, photoMixin],
    methods: {
        fa_stars_regular,
        closeModal,
        goToPremium,
    },
    components: {IconComponent, RegularEscortViewComponent},
}
</script>
